import React, {Component} from 'react';
import {Button, Calendar, Card, Col, Icon, Layout, List, Radio, Row,} from 'antd';
import moment from 'moment';
import {isBigEnough} from '../helper/uiHelper';
import {injectIntl} from 'react-intl';
import connect from 'react-redux/es/connect/connect';
import {withRouter} from 'react-router-dom';
import {Spinner} from '../../components/UIToolbox';
import {DRIVE_IN_MANDATORY, DRIVE_IN_ON_REQUEST, DRIVE_IN_RECEPTION, HOME_SERVICE_MOBILITY, isMobilityRental, STANDARD_RECEPTION, TIRES, TIRES_EXCHANGE, WAIT_MOBILITY,} from '../definition/business';
import FieldError from '../../../components/common/input/FieldError';
import SAInfoBubble from '../../../components/common/confirmation/SAInfoBubble';

class DateReceptionFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookableDays: [],
      bookableDaysList: [],
      fetching: false,
    };
  }

  componentDidMount() {
    if (!this.props.selectedDate) {
      this.props.dispatchFetchAvailabilities({
        dealerId: this.props.selectedDealer.id,
        body: {
          homeService: this.props.createAppointmentRequest.chosenMobility && this.props.createAppointmentRequest.chosenMobility.mobilityOption === HOME_SERVICE_MOBILITY,
          services: this.props.createAppointmentRequest.selectedOptions.map(o => o.id),
          waitingAtDealership: this.props.createAppointmentRequest.chosenMobility && this.props.createAppointmentRequest.chosenMobility.mobilityOption === WAIT_MOBILITY,
          bookingToken: this.props.publicContext.bookingToken,
          mobility: this.props.createAppointmentRequest.chosenMobility && this.props.createAppointmentRequest.chosenMobility.mobilityOption,
        },
      });
      this.setState({fetching: true});
    } else {
      const bookableDays = this.props.availabilities.availabilities.filter(this.filterDate);
      const bookableDaysList = this.props.availabilities.availabilities
        .filter(this.filterDate)
        .map(availability => availability.day);
      this.setState({bookableDays, bookableDaysList, fetching: false});
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.availabilities && !this.props.selectedDate) {
      const bookableDays = nextProps.availabilities.availabilities.filter(this.filterDate);
      const bookableDaysList = nextProps.availabilities.availabilities
        .filter(this.filterDate)
        .map(availability => availability.day);
      this.setState({bookableDays, bookableDaysList, fetching: false});
    }
  }

  filterDate = availability => {
    if (availability.status !== 'OPEN' || !availability.availableSlots.length) {
      return false;
    }
    const chosenMobility = this.props.createAppointmentRequest.chosenMobility;
    if (chosenMobility && isMobilityRental(chosenMobility.mobilityOption, this.props.mobility.categoryMobility) && availability.mobility) {
      return availability.mobility.includes(chosenMobility.mobilityOption);
    }
    return true;
  };

  dateFullCellRender = date => {
    const isBeforeToday = date.isBefore(moment());
    const res = this.state.bookableDaysList.find(d => date.format('YYYY-MM-DD') === d);
    const color = isBeforeToday ? 'calendar-box--expired' : (!res ? 'calendar-box--closed' : 'calendar-box--available');
    return (
      <div className={`${color} ant-fullcalendar-value ant-fullcalendar-date`} style={{width: '100%'}}>
        <div style={{position: 'relative'}}>
          {moment(date).format('D')}
        </div>
      </div>
    );
  };

  onSelectSlotClosure = slot => () => {
    this.props.onSelectSlot(slot);
  };

  onReceptionChangeClosure = reception => () => {
    this.props.onReceptionChange(reception);
  };

  hasOption = optionId => !!this.props.createAppointmentRequest.selectedOptions.find(o => o.id === optionId);

  render() {
    const {
      intl: {formatMessage, locale},
      onSelectDate,
      selectedDate,
      selectedSlot,
      reception,
      sizeClass,
      selectedDealer,
      selectedVehicle,
      untrustedVinwOffering,
      type,
    } = this.props;
    const now = moment();
    const limit = moment(now).add(3, 'M');
    let current = moment(now);
    const out = [];
    while (current.isSameOrBefore(limit)) {
      out.push(current.month());
      current = current.add(1, 'month');
    }
    const bookableSelectedDate = this.state.bookableDays.find(availability =>
      moment(availability.day).isSame(moment(selectedDate))
    );
    const radioStyle = {
      display: 'block',
      height: '50px',
      lineHeight: '50px',
    };
    const isBig = isBigEnough(sizeClass);
    let brandedReception;

    if (untrustedVinwOffering) {
      brandedReception = untrustedVinwOffering;
    } else {
      brandedReception = selectedVehicle.brand.startsWith('BMW') ? selectedDealer.receptionOffering.bmwOffering : selectedDealer.receptionOffering.miniOffering;
    }

    if (brandedReception.driveIn === DRIVE_IN_MANDATORY && reception !== DRIVE_IN_RECEPTION) {
      this.onReceptionChangeClosure(DRIVE_IN_RECEPTION)();
    }

    let shouldDisplayReception = selectedDate && selectedSlot;
    if (type === TIRES) {
      shouldDisplayReception = selectedDate && selectedSlot && this.hasOption(TIRES_EXCHANGE);
    }

    if (this.state.fetching) {
      return <Spinner/>;
    }
    return (
      <Layout style={{backgroundColor: 'transparent'}}>
        <Card
          title={
            <h2>
              {formatMessage({id: 'customer.journey.step.dateReception.dateTitle'}).toUpperCase()}
            </h2>
          }
          bordered={false}
          style={{width: '100%', marginBottom: 25}}
        >
          <Row>
            <Col span={12} xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} style={{paddingRight: isBig ? 25 : 0, paddingBottom: 25}}>
              <ul className="list" style={{paddingBottom: 10}}>
                {selectedDealer.holidaysAnnounce &&
                  selectedDealer.holidaysAnnounce[locale] && (
                    <li>
                      {`${formatMessage({id: 'customer.journey.step.dateReception.holidayAnnouncement'})} ${selectedDealer.holidaysAnnounce[locale]}`}
                    </li>
                  )}
                <li>
                  {formatMessage({id: 'customer.journey.step.dateReception.chooseDateAdvise'})}
                </li>
                <li>
                  {!selectedDate && (
                    <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
                  )}
                </li>
              </ul>
              <div className="shadow">
                <Calendar
                  ref={this._calendarRef}
                  fullscreen={false}
                  onPanelChange={this.onPanelChange}
                  validRange={[now, limit]}
                  disabledDate={date =>
                    !this.state.bookableDaysList.find(
                      d => date.format('YYYY-MM-DD') === d
                    )
                  }
                  dateFullCellRender={this.dateFullCellRender}
                  onSelect={onSelectDate}
                  headerRender={({value, type, onChange}) => {
                    const localeData = value.localeData();
                    const currentMonth = value.month();
                    // workaround to modulo with negative value
                    const previous = out.includes((((currentMonth - 1) % 12) + 12) % 12);
                    const next = out.includes((currentMonth + 1) % 12);
                    return (
                      <Row
                        type="flex"
                        justify="space-between"
                        align="middle"
                        style={{paddingTop: 16, paddingBottom: 16}}
                      >
                        <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
                          <Button
                            type="link"
                            onClick={
                              previous
                                ? () => {
                                  onChange(value.clone().month(currentMonth - 1));
                                }
                                : null
                            }
                          >
                            <Icon type="left" className={previous ? 'branded-color' : 'branded-color-disabled'}/>
                          </Button>
                        </Col>
                        <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
                          {localeData._months[currentMonth]}
                        </Col>
                        <Col span={8} style={{display: 'flex', justifyContent: 'center'}}>
                          <Button
                            type="link"
                            onClick={
                              next
                                ? () => {
                                  onChange(value.clone().month(currentMonth + 1));
                                }
                                : null
                            }
                          >
                            <Icon type="right" className={next ? 'branded-color' : 'branded-color-disabled'}/>
                          </Button>
                        </Col>
                      </Row>
                    );
                  }}
                />
              </div>
            </Col>
            {bookableSelectedDate && selectedDate ? (
              <Col span={12} xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                <ul className="list">
                  <li>
                    {!selectedSlot && (
                      <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
                    )}
                  </li>
                  <li>
                    <List
                      grid={{gutter: 16, xs: 2, sm: 4, md: 4, lg: 2, xl: 1, xxl: 2}}
                      dataSource={bookableSelectedDate.availableSlots}
                      renderItem={item => (
                        <List.Item>
                          <Button
                            style={{
                              backgroundColor: selectedSlot && item.startTime === selectedSlot.startTime ? '#3F7F2A' : 'white',
                              borderRadius: 0,
                              color: selectedSlot && item.startTime === selectedSlot.startTime ? 'white' : 'black'
                            }}
                            onClick={this.onSelectSlotClosure(item)}
                          >
                            {`${item.endTime ? moment(item.startTime, 'hh:mm:ss').format('HH:mm') : item.startTime} ${item.endTime ? `- ${moment(item.endTime, 'hh:mm:ss').format('HH:mm')}` : ''} `}
                          </Button>
                        </List.Item>
                      )}
                    />
                  </li>
                </ul>
              </Col>
            ) : null}
          </Row>
        </Card>
        {shouldDisplayReception && (
          <Card
            title={
              <h2>
                {formatMessage({id: 'customer.journey.step.dateReception.receptionTitle'}).toUpperCase()}
              </h2>
            }
            bordered={false}
            style={{width: '100%'}}
          >
            <Row>
              <ul className="list">
                <li>
                  {formatMessage({id: 'customer.journey.step.dateReception.chooseReceptionAdvice'})}
                  {!reception && (
                    <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
                  )}
                </li>
                <li>
                  {brandedReception.driveIn !== DRIVE_IN_MANDATORY ? (
                    <Radio
                      checked={reception === STANDARD_RECEPTION}
                      value="standard"
                      style={radioStyle}
                      onClick={this.onReceptionChangeClosure(STANDARD_RECEPTION)}
                    >
                      {formatMessage({id: 'customer.journey.step.dateReception.standardReception'})}
                    </Radio>
                  ) : null}
                  {brandedReception.driveIn === DRIVE_IN_ON_REQUEST ||
                  brandedReception.driveIn === DRIVE_IN_MANDATORY ? (
                    <Row type="flex" align="middle">
                      <Col span={20}>
                        <Radio
                          checked={reception === DRIVE_IN_RECEPTION}
                          value={DRIVE_IN_RECEPTION}
                          style={radioStyle}
                          onClick={this.onReceptionChangeClosure(DRIVE_IN_RECEPTION)}
                        >
                          {formatMessage({id: 'customer.journey.step.dateReception.driveInReception'})}
                        </Radio>
                      </Col>
                      <Col span={4}>
                        <SAInfoBubble content={formatMessage({id: 'customer.journey.step.dateReception.driveInReception.description'})}/>
                      </Col>
                    </Row>
                  ) : null}
                </li>
              </ul>
            </Row>
          </Card>
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchAvailabilities: params => dispatch({type: 'FETCH.CUSTOMER_AVAILABILITIES.REQUEST', params})
});

const mapStateToProps = state => ({
  availabilities: state.availabilities.availabilities,
  createAppointmentRequest: state.createAppointmentRequest,
  selectedVehicle: state.customerVehicle.selectedVehicle,
  publicContext: state.publicContext,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(DateReceptionFragment))
);
